import { render, staticRenderFns } from "./softEdit.vue?vue&type=template&id=3dbdbc45&scoped=true"
import script from "./softEdit.vue?vue&type=script&lang=js"
export * from "./softEdit.vue?vue&type=script&lang=js"
import style0 from "./softEdit.vue?vue&type=style&index=0&id=3dbdbc45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbdbc45",
  null
  
)

export default component.exports